import axiosNest from '../../api/axiosNest';

/**
 * „Mój profil” — wywołania API (`apps/api/src/users/own-profile.controller.ts`).
 *
 * Imię i nazwisko własnego konta (decyzja użytkownika 07.10.2026: w API TMS
 * ani w telematyce ich nie ma, więc wpisuje je sam użytkownik). Trasa nie
 * przyjmuje identyfikatora konta — API bierze go z tokenu — i zmienia
 * wyłącznie te dwa pola.
 */

export const OWN_PROFILE_URL = '/users/me';

/** Najdłuższe imię i nazwisko — jak w API (`MAX_PERSON_NAME_LENGTH`). */
export const MAX_PERSON_NAME_LENGTH = 100;

export interface OwnProfile {
  id: number;
  username: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  /** Imię i nazwisko, gdy wpisane; inaczej login. */
  displayName: string | null;
}

const text = (v: unknown): string | null => (typeof v === 'string' && v.trim() !== '' ? v : null);

function normalize(data: Partial<OwnProfile> | undefined): OwnProfile {
  return {
    id: Number(data?.id),
    username: typeof data?.username === 'string' ? data.username : '',
    email: typeof data?.email === 'string' ? data.email : '',
    firstName: text(data?.firstName),
    lastName: text(data?.lastName),
    displayName: text(data?.displayName),
  };
}

export async function fetchOwnProfile(): Promise<OwnProfile> {
  const { data } = await axiosNest.get<Partial<OwnProfile>>(OWN_PROFILE_URL);
  return normalize(data);
}

/** Zapis imienia i nazwiska. Puste pole = brak (API zapisze NULL). */
export async function saveOwnProfile(input: { firstName: string; lastName: string }): Promise<OwnProfile> {
  const { data } = await axiosNest.patch<Partial<OwnProfile>>(OWN_PROFILE_URL, {
    firstName: input.firstName.trim() === '' ? null : input.firstName.trim(),
    lastName: input.lastName.trim() === '' ? null : input.lastName.trim(),
  });
  return normalize(data);
}
